import { Feature, type FeatureType } from "src/states/ApplicationState";

export type ServitutRedegoerelsePhase = "A" | "B";

function hasLegacyPhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelseA)
      || hasAccessToFeature(Feature.ServitutRedegoerelseAView);
}

function hasLegacyPhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelseBView);
}

export function canUseServitutRedegoerelse(
   hasAccessToFeature: (feature: FeatureType) => boolean,
): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse) || hasLegacyPhaseA(hasAccessToFeature);
}

export function canUsePhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return canUseServitutRedegoerelse(hasAccessToFeature);
}

export function canUsePhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelseB) || hasLegacyPhaseB(hasAccessToFeature);
}

export function canWritePhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return canUsePhaseA(hasAccessToFeature);
}

export function canWritePhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return canUsePhaseB(hasAccessToFeature);
}
